
export class Children{
    /*
   *
   */
    constructor(
        public id?: number,
        public type?: string
    ){}
}